import React, { useState } from 'react';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';
import { DesktopDatePicker } from '@mui/x-date-pickers';

const Selector = ({ id, date, automationStore }) => {
  const [changed, setChanged] = useState(0);
  const showOneField = automationStore.oneField;
  const showTwoFields = automationStore.twoFields;

  const setFilterValue = (field, value) => {
    automationStore.setFilter(id, field, value);
    setChanged(changed + 1);
  }

  return (
    <>
      <div>
        <FormControl fullWidth>
          <Select
            value={automationStore.getFilter(id, 'type')}
            onChange={e => setFilterValue('type', e.target.value)}
          >
            <MenuItem value='all'>Todos</MenuItem>
            <MenuItem value='greatherThan'>Maior</MenuItem>
            <MenuItem value='greatherThanOrEqual'>Maior ou Igual</MenuItem>
            <MenuItem value='equal'>Igual</MenuItem>
            <MenuItem value='lessThan'>Menor</MenuItem>
            <MenuItem value='lessThanOrEqual'>Menor or Igual</MenuItem>
            <MenuItem value='between'>Entre</MenuItem>
          </Select>
        </FormControl>
      </div>
      <br />
      {automationStore.getFilter(id, 'type') && showOneField.includes(automationStore.getFilter(id, 'type')) && (
        <div>
          {date === true && (
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DesktopDatePicker
                label='Data'
                inputFormat='DD/MM/YYYY'
                value={automationStore.getFilter(id, 'from')}
                onChange={newValue => setFilterValue('from', newValue)}
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
            </LocalizationProvider>
          )}
          {date !== true && (
            <TextField id='from' label='Valor' variant='outlined' fullWidth
                       value={automationStore.getFilter(id, 'from')}
                       onChange={e => setFilterValue('from', e.target.value)}
            />
          )}
        </div>
      )}
      {automationStore.getFilter(id, 'type') && showTwoFields.includes(automationStore.getFilter(id, 'type')) && (
        <>
          {date === true && (
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DesktopDatePicker
                label='De'
                inputFormat='DD/MM/YYYY'
                value={automationStore.getFilter(id, 'from')}
                onChange={newValue => setFilterValue('from', newValue)}
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
              <br /><br />
              <DesktopDatePicker
                label='Até'
                inputFormat='DD/MM/YYYY'
                value={automationStore.getFilter(id, 'to')}
                onChange={newValue => setFilterValue('to', newValue)}
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
            </LocalizationProvider>
          )}
          {date !== true && (
            <div>
              <TextField id='from' label='Valor' variant='outlined' fullWidth
                         value={automationStore.getFilter(id, 'from')}
                         onChange={e => setFilterValue('from', e.target.value)}
              />
              <br /><br />
              <TextField id='to' label='Valor' variant='outlined' fullWidth
                         value={automationStore.getFilter(id, 'to')}
                         onChange={e => setFilterValue('to', e.target.value)}
              />
            </div>
          )}
        </>
        )}
    </>
  );
};

export default Selector;
